// extracted by mini-css-extract-plugin
export default {"home":"Home_home__ANI56","main_layout":"Home_main_layout__w9A0O","main_layout_text":"Home_main_layout_text__Ygwi4","parts":"Home_parts__C5xBq"};